/* global axios */
import ApiClient from './ApiClient';

// A SECRETÁRIA (21/10/2026): o cartão de confirmar o que o Copiloto propôs. Só quem pediu acha a proposta.
class SecretariaAPI extends ApiClient {
  constructor() {
    super('secretaria_acoes', { accountScoped: true });
  }

  confirmar(id) {
    return axios.post(`${this.url}/${id}/confirmar`);
  }

  recusar(id) {
    return axios.post(`${this.url}/${id}/recusar`);
  }

  desfazer(id) {
    return axios.post(`${this.url}/${id}/desfazer`);
  }
}

export default new SecretariaAPI();
